import React from "react";
import { useEffect } from "react";
import { Outlet } from "react-router-dom";
import { allowUserLogin } from "../../Helpers";

const CompanyHome = () => {
  const [loadComponent, setLoadComponent] = React.useState(false);
  useEffect(() => {
    allowUserLogin("Company")?.then(setLoadComponent);
  }, []);
  return loadComponent && <Outlet />;
};

export default CompanyHome;
